var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSubpasta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.988,
    height: 25,
    viewBox: "0 0 24.988 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#596778;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24.988,
    height: 24.988,
    transform: "translate(0 0.012)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M319.561,353.983h-5.1a1.041,1.041,0,0,1-.926-.564l-.718-1.383a1.735,1.735,0,0,0-1.546-.937h-3.207a1.743,1.743,0,0,0-1.742,1.742v9.737a1.742,1.742,0,0,0,1.742,1.741h11.492a1.74,1.74,0,0,0,1.741-1.741v-6.854A1.741,1.741,0,0,0,319.561,353.983ZM308.069,351.8h3.207a1.038,1.038,0,0,1,.926.564l.718,1.382a1.935,1.935,0,0,0,.15.241h-6.046v-1.139A1.048,1.048,0,0,1,308.069,351.8Zm12.537,10.782a1.048,1.048,0,0,1-1.045,1.044H308.069a1.046,1.046,0,0,1-1.045-1.044v-7.9h7.1a.347.347,0,0,0,.1-.014,1.8,1.8,0,0,0,.244.017h5.091a1.049,1.049,0,0,1,1.045,1.045Z",
    transform: "translate(-296.575 -341.014)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M301.93,341.038v17.638a1.74,1.74,0,0,0,1.741,1.741h2.656v-.52h-1.884a2.564,2.564,0,0,1-1.466-.245,1.442,1.442,0,0,1-.527-1.042v-17.6Z",
    transform: "translate(-296.575 -341.014)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSubpasta);
export default __webpack_public_path__ + "static/media/ico-subpasta.85598e4d5cad5ffef945a0d5f88803c7.svg";
export { ForwardRef as ReactComponent };